import toast from "react-hot-toast";
import axiosInstance from "../../axiosInstance";
import { secureStorage } from "../../utils/secureStorage";
const adminToken = secureStorage.getItem("adminToken");

export const addCompany = (FormData, setFormData, navigate) => {
  axiosInstance
    .post("/company/add", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Company added successfully") {
        toast.success("Company added");
        setFormData({
          companyName: "",
          companyLogo: "",
          address: "",
          primaryPhoneNumber: "",
          alternativePhoneNumber: "",
          email: "",
          password: "",
          commissionRate: 0,
          type: "Hotel",
          koc_fullName: "",
          koc_profilePicture: "",
          koc_phoneNumber: "",
          koc_email: "",
          koc_designation: "",
          agreement: "",
          tradelicense: "",
          nid: "",
          bin: "",
          tin: "",
          incorporation: "",
          isVerified: 1,
        });
        navigate("/admin/companies");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const getCompanyList = (
  setCompanyData,
  Page,
  Limit,
  setPaginationData
) => {
  axiosInstance
    .get(`/company/list?page=${Page}&limit=${Limit}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setCompanyData(res.data.data);
      setPaginationData(res.data.totalPages);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const getSingleCompany = (id, setFormData) => {
  axiosInstance
    .get(`/company/get/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setFormData({
        id: res.data.id,
        companyName: res.data.companyName,
        companyLogo: res.data.companyLogo,
        address: res.data.address,
        primaryPhoneNumber: res.data.primaryPhoneNumber,
        alternativePhoneNumber: res.data.alternativePhoneNumber,

        email: res.data.email,
        password: "",

        commissionRate: res.data.commissionRate,
        type: res.data.type,

        koc_fullName: res.data.koc_fullName,
        koc_profilePicture: res.data.koc_profilePicture,
        koc_phoneNumber: res.data.koc_phoneNumber,
        koc_email: res.data.koc_email,
        koc_designation: res.data.koc_designation,

        agreement: res.data.agreement,
        tradelicense: res.data.tradelicense,
        nid: res.data.nid,
        bin: res.data.bin,
        tin: res.data.tin,
        incorporation: res.data.incorporation,

        isVerified: res.data.isVerified,
        status: res.data.status,
        created_by: res.data.created_by,
        createdAt: res.data.createdAt,
      });
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};

export const updateCompany = (FormData, navigate) => {
  axiosInstance
    .put("/company/update", FormData, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Company updated successfully") {
        toast.success("Company updated");

        navigate("/admin/companies");
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const deleteCompany = (
  setCompanyData,
  setPaginationData,
  Page,
  Limit,
  id
) => {
  axiosInstance
    .delete(`/company/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Company deleted successfully") {
        toast.success("Company deleted");
        getCompanyList(setCompanyData, Page, Limit, setPaginationData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};

export const toggleStatus = (
  setCompanyData,
  setPaginationData,
  Page,
  Limit,
  id
) => {
  axiosInstance
    .put(`/company/toggle-status/${id}`, {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      if (res.data.message === "Status toggled successfully") {
        toast.success("Status changed");
        getCompanyList(setCompanyData, Page, Limit, setPaginationData);
      } else {
        toast.error(res.data.message);
      }
    })
    .catch((err) => {
      toast.error("something went Wrong");
    });
};
export const allCompanies = (setData) => {
  axiosInstance
    .get("/company/companies", {
      headers: {
        Authorization: `Bearer ${adminToken}`,
        "Content-Type": "application/json",
      },
    })
    .then((res) => {
      setData(res.data.data);
    })
    .catch((err) => {
      toast.error("Data is not found");
    });
};
